/* KEY CODES */
// use https://keycode.info/ for key values
export const KEY_B = "b";
export const KEY_SPACE = " ";
export const KEY_ENTER = "Enter";
export const KEY_ARROW_DOWN = "ArrowDown";
export const KEY_ARROW_UP = "ArrowUp";
export const KEY_BACKSPACE = "Backspace";
export const KEY_DELETE = "Delete";
export const KEY_ESCAPE = "Escape";
export const KEY_COMMA = ",";
export const KEY_TAB = "Tab";
